import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

export function useLabelVisibility() {
  const labels = useMapGetter('labels/getLabels');
  const allTeams = useMapGetter('teams/getTeams');
  const myTeams = useMapGetter('teams/getMyTeams');

  const visibleTeams = computed(() => myTeams.value);
  const myTeamIds = computed(
    () => new Set(myTeams.value.map(team => Number(team.id)))
  );
  const teamLabelGroups = computed(() =>
    visibleTeams.value
      .map(team => ({
        id: team.id,
        name: team.name,
        labels: labels.value.filter(
          label => Number(label.team_id) === Number(team.id)
        ),
      }))
      .filter(group => group.labels.length)
  );
  const teamLabels = computed(() =>
    teamLabelGroups.value.flatMap(group => group.labels)
  );
  const sharedLabels = computed(() =>
    labels.value.filter(label => label.team_id === null)
  );
  const visibleLabels = computed(() => [
    ...teamLabels.value,
    ...sharedLabels.value,
  ]);
  const isMyTeamLabel = label =>
    label.team_id !== null && myTeamIds.value.has(Number(label.team_id));

  return {
    labels,
    allTeams,
    myTeams,
    visibleTeams,
    teamLabelGroups,
    teamLabels,
    sharedLabels,
    visibleLabels,
    isMyTeamLabel,
  };
}
